import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

const PageLoader = ({ text = "Loading" }: { text?: string }) => {
  const [dots, setDots] = useState("");
  const [show, setShow] = useState(false);

  // Delay appearance to absorb sub-frame React reconciliation (fast cache/fetch = no spinner visible)
  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 150);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? "" : prev + "."));
    }, 400);
    return () => clearInterval(interval);
  }, []);

  if (!show) {
    // Return completely transparent background during the delay to prevent white flash on mesh gradients
    return <div className="min-h-screen bg-transparent" />;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25 }}
      className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background"
    >
      <div className="relative h-10 w-10 flex items-center justify-center">
        {/* Track Ring (Subtle) */}
        <div className="absolute inset-0 rounded-full border-[1.5px] border-primary/5" />
        
        {/* Active Spinner - Minimalist 1.5px */}
        <motion.div
          className="absolute inset-0 rounded-full border-[1.5px] border-primary border-t-transparent"
          animate={{ rotate: 360 }}
          transition={{ duration: 0.8, repeat: Infinity, ease: 'linear' }}
        />
      </div>

      <div className="flex flex-col items-center">
        <p className="text-[11px] font-medium text-primary/80 uppercase tracking-[0.2em] flex items-center min-w-[80px] justify-center">
          {text}
          <span className="inline-block w-4 text-left">{dots}</span>
        </p>
      </div>
    </motion.div>
  );
};

export default PageLoader;
